<template>
  <div>
    <label class="control-label"
      >{{ title }}
      <span v-show="tempUpload" @click="clear" class="bold">
        - Отмена</span
      ></label
    >
    <div class="draw-image">
      <img :src="value ? value : noImage" alt="" />
      <input
        ref="fileupload"
        accept="image/*"
        type="file"
        @change="handleFileUpload"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: ["title", "value"],
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (file.size > 51000000) {
          this.$notify({
            title: "Ошибка",
            message: "Файл более 50 мб. весит",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          try {
            let MAX_WIDTH = 1920;
            let img = document.createElement("img");
            img.src = reader.result;
            img.onload = () => {
              let canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;
              let newHeight = height;
              let newWidth = width;
              let ctx = canvas.getContext("2d");
              if (width > MAX_WIDTH) {
                newHeight = (MAX_WIDTH * height) / width;
                newWidth = MAX_WIDTH;
              }
              canvas.height = newHeight;
              canvas.width = newWidth;
              ctx.drawImage(img, 0, 0, newWidth, newHeight);

              this.$emit("input", canvas.toDataURL("image/png"));
            };
          } catch (e) {
            this.$emit("input", reader.result);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.draw-image {
  cursor: pointer;
  position: relative;
  height: 0;
  padding-top: 50%;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-bottom: 30px;
  input {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  img {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
</style>